import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Component() {
  const navigate = useNavigate();
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const code = params.get("code");
  const sourceCode = localStorage.getItem("source");

  useEffect(() => {
    if (code) {
      let uuidAuth = localStorage.getItem("uuid");
      let pageType = localStorage.getItem("pageType");
      let tableId = localStorage.getItem("tableId");

      localStorage.setItem("login", "Login");

      if (sourceCode === "sharepoint") {
        localStorage.setItem("codeSharepoint", code);
      } else if (sourceCode === "oneDrive") {
        localStorage.setItem("codeoneDrive", code);
      }

      localStorage.removeItem("source");

      if (pageType === "builder" && uuidAuth) {
        navigate(`/dashboard/mainDashboard/${uuidAuth}`);
      } else if (pageType === "kb" && tableId) {
        navigate(`/dashboard/knowledgebase/tabledetail/${tableId}`);
        localStorage.removeItem("tableId");
      } else {
        navigate(`/assistant/launch?uuid=${uuidAuth}`);
      }

      localStorage.removeItem("pageType");
    }
  }, [code, navigate]);

  return <div>Waiting for the Authentication...</div>;
}
